import myAxios from '../utils/my-axios';

export const verifyApiKey = async (apiKey: string): Promise<void> => {
  const { data } = await myAxios.get('/admin/verify-admin-api-key', {
    headers: {
      'x-api-key': apiKey,
    },
  });

  return data;
};

export const refreshRaffleStates = async (): Promise<void> => {
  const { data } = await myAxios.get(`/raffles/update-states`);

  return data;
};
